import React, { Component } from 'react';
import Page404 from '../404';
import ProductTitle from './components/product.title';
import ProductGalleryMain from './components/product.gallery-main';
import ProductName from './components/product.name';
import ProductPrice from './components/product.price';
import ProductDescription from './components/product.description';
import ProductShare from './components/product.share-social';
import FsLightbox from 'fslightbox-react';
import classNames from 'classnames';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../store/actions';
import { API, STAR } from '../../constants';
import DialogProductOverStock from '../Dialog/dialog.product-over-stock';
import DialogAddProductToCart from '../Dialog/dialog.add-product-to-cart';
import { withRouter, Link } from 'react-router-dom';
import { formatDate } from '../../utils/';
import StarRatings from 'react-star-ratings';

class ProductMain extends Component {
  state = {
    itemSelected: null,
    galleryResource: null,
    thumbSelected: 0,
    lightboxOpen: false,
    lightboxSlide: 1,
    lightboxSource: null,
    qty: 0,
    btnAddItemToCartAndBuyNow: true,
    colors: [],
    sizes: [],
    pictures: [],
    sizeSelected: false
  };

  componentDidMount() {
    const { product, type, getItemReview } = this.props;

    if (product && type === 'product' && product.items.length !== 0) {
      const { product } = this.props;
      const { items } = product;

      const colors = _.chain(items)
        .groupBy('colorCode')
        .map((value, name) => ({ name }))
        .value();

      const orderBy = ['S', 'M', 'L', 'XL'];
      const itemSort = items.sort(
        (a, b) => orderBy.indexOf(a.sizeName) - orderBy.indexOf(b.sizeName)
      );

      const itemSelected = this.filterItemSelected(itemSort);
      const lightboxSource = this.createLightBoxSource(itemSelected.pictures);
      const sizes = this.filterSizeSelected(itemSort, itemSelected.colorCode);

      this.setState({
        itemSelected: itemSelected,
        sizeSelected: sizes.length === 1,
        btnAddItemToCartAndBuyNow:
          sizes.length === 1 && itemSelected.stockAvailable > 0 ? false : true,
        qty: sizes.length === 1 && itemSelected.stockAvailable > 0 ? 1 : 0,
        galleryResource: itemSelected.pictures[0],
        lightboxSource: lightboxSource,
        colors: colors,
        sizes: sizes
      });
    } else if (product && type === "voucher") {
      const { product } = this.props;

      const lightboxSource = this.createLightBoxSource(product.pictures);
      this.setState({
        itemSelected: product,
        sizeSelected: true,
        btnAddItemToCartAndBuyNow: product.stockAvailable > 0 ? false : true,
        qty: product.stockAvailable > 0 ? 1 : 0,
        galleryResource: product.pictures[0],
        lightboxSource: lightboxSource
      });
    }
  }

  filterItemsById = (data, id) => {
    return _.filter(data, (item) => item.colorCode === id);
  };

  filterSizeSelected = (items, color) => {
    const orderBy = ['S', 'M', 'L', 'XL'];
    return _.chain(items)
      .filter((item) => item.colorCode == color)
      .groupBy('sizeName')
      .map((value, key) => key)
      .value()
      .sort((a, b) => orderBy.indexOf(a) - orderBy.indexOf(b));
  };

  filterItemSelected = (data) => {
    let itemSelected = null;
    data.some((itemData) => {
      itemSelected = itemData;
      if (itemData.stockAvailable > 0) {
        return true;
      }
      return false;
    });

    return itemSelected;
  };

  createLightBoxSource = (data) => {
    const source = data.map((d) => {
      return `${API.PRODUCT_IMG_URL}${d}`;
    });
    return source;
  };

  handleOpenLightbox = () => {
    const { lightboxOpen } = this.state;
    this.setState({ lightboxOpen: !lightboxOpen });
  };

  handleThumbSelected = (index, image) => {
    this.setState({
      thumbSelected: index,
      galleryResource: image,
      lightboxSlide: index + 1
    });
  };

  handleColorChange = (data) => {
    const { items } = this.props.product;

    const itemSelected = items.filter((item) => item.colorCode == data)[0];
    const lightboxSource = this.createLightBoxSource(itemSelected.pictures);
    const sizes = this.filterSizeSelected(items, data);

    this.setState({
      itemSelected: itemSelected,
      galleryResource: itemSelected.pictures[0],
      lightboxSource: lightboxSource,
      sizeSelected: sizes.length === 1,
      btnAddItemToCartAndBuyNow:
        sizes.length === 1 && itemSelected.stockAvailable > 0 ? false : true,
      qty: sizes.length === 1 && itemSelected.stockAvailable > 0 ? 1 : 0,
      sizes: sizes
    });
  };

  handleSizeChange = (size) => {
    const { itemSelected } = this.state;
    const { product } = this.props;
    const { items } = product;

    const newItemSelected = items.filter(
      (item) =>
        item.colorCode == itemSelected.colorCode && item.sizeName == size
    )[0];
    const lightboxSource = this.createLightBoxSource(newItemSelected.pictures);
    const outOfStock = newItemSelected.stockAvailable === 0;

    this.setState({
      sizeSelected: true,
      galleryResource: newItemSelected.pictures[0],
      itemSelected: newItemSelected,
      btnAddItemToCartAndBuyNow: outOfStock,
      lightboxSource: lightboxSource,
      qty: outOfStock ? 0 : 1
    });
  };

  handleIncreaseQty = () => {
    const { type } = this.props;
    let amountInCart = this.findAmountInCart();
    this.setState((prevState) => {
      if (type == "voucher" && amountInCart >= 10)
        return { qty: prevState.qty };
      if (prevState.qty < prevState.itemSelected.stockAvailable)
        return { qty: prevState.qty + 1 };
    });
  };

  handleDecreaseQty = () => {
    this.setState((prevState) => {
      if (prevState.qty > 1) return { qty: prevState.qty - 1 };
    });
  };

  handleQtyChange = (e) => {
    const qty = e.target.value;
    this.setState((prevState) => {
      return {
        qty:
          qty > prevState.itemSelected.amount
            ? prevState.itemSelected.amount
            : qty
      };
    });
  };

  handleQtyBlur = () => {
    const { qty, itemSelected } = this.state;
    const { type } = this.props;
    let amountInCart = this.findAmountInCart();
    const newQty =
      (qty === '' || qty <= 0) && itemSelected.stockAvailable === 0
        ? 0
        : (qty === '' || qty <= 0) && itemSelected.stockAvailable > 0
          ? 1
          : itemSelected.stockAvailable < qty
            ? itemSelected.stockAvailable
            : amountInCart > 10 && type == "voucher"
              ? 10 - (amountInCart - qty)
              : qty;
    this.setState({ qty: newQty });
  };

  handleAddToCart = async () => {
    const { itemSelected, qty, btnAddItemToCartAndBuyNow } = this.state;

    const {
      cart,
      CreateCart,
      AddOrUpdateProductToCart,
      OpenDialogProductOverStock,
      type,
      AddToBuyNow,
      product,
    } = this.props;

    if (!btnAddItemToCartAndBuyNow) {

      const AmountOfItemInCart = this.findAmountInCart();

      if ((AmountOfItemInCart > itemSelected.stockAvailable) || (AmountOfItemInCart > 10 && type == "voucher")) {
        OpenDialogProductOverStock();
        this.handleDialogProductOverStock();
      } else {
        const model = {
          itemId: itemSelected.id,
          itemName: product.name,
          sizeName: itemSelected.sizeName,
          qty: qty,
          rgbColor: itemSelected.colorCode,
          promotionPrice: itemSelected.promotionPrice,
          price: itemSelected.price,
          itemStock: itemSelected.stockAvailable,
          cartItemImage: itemSelected.pictures[0],
          promotionCodeDirect: itemSelected.promotionCodeDirect,
          promotionCodeDiscountCode: itemSelected.promotionCodeDiscountCode,
          dimension: itemSelected.dimension || 0,
          vistaCode: itemSelected.vistaCode,
          weight: itemSelected.weight
        };

        if (type !== "voucher") {
          if ((cart || []).length === 0 && !localStorage.getItem("cartGuest")) {
            await CreateCart(model, 'add');
            await this.handleDialogAddProductToCart();
          } else {
            await AddOrUpdateProductToCart(model, 'add');
            await this.handleDialogAddProductToCart();
          }
        } else {
          AddToBuyNow({ ...model, type: "voucher" }, 'add');
        }
      }
    }
  };

  handleDialogAddProductToCart = () => {
    const { GetCartData, AutoCloseDialogAddProductToCart } = this.props;
    setTimeout(async () => {
      await AutoCloseDialogAddProductToCart();
      await GetCartData();
      await this.setState({ qty: 1 });
    }, 1500);
  };

  findAmountInCart = () => {
    const { itemSelected, qty } = this.state;
    const { type, buyNow, cart } = this.props;
    if (type === "voucher") {
      return _.sumBy(buyNow, (item) => item.qty) + +qty;
    } else {
      let FindItemInCart = _.filter(cart, (item) => item.itemId === itemSelected.id);
      return FindItemInCart.length === 0 ? 0 + qty : FindItemInCart[0].qty + qty;
    }
  }

  handleBuyNow = async () => {
    const { btnAddItemToCartAndBuyNow, itemSelected, qty } = this.state;

    const {
      OpenDialogLogin,
      cart,
      OpenDialogProductOverStock,
      CreateCart,
      AddOrUpdateProductToCart,
      GetCartData,
      history,
      product,
      type,
      AddToBuyNow,
      basenameURL,
    } = this.props;

    if (!btnAddItemToCartAndBuyNow) {
      
      const AmountOfItemInCart = this.findAmountInCart();

      if ((AmountOfItemInCart > itemSelected.stockAvailable) || (AmountOfItemInCart > 10 && type == "voucher")) {
        OpenDialogProductOverStock();
        this.handleDialogProductOverStock();
      } else {
        const model = {
          itemId: itemSelected.id,
          itemName: product.name,
          sizeName: itemSelected.sizeName,
          qty: qty,
          rgbColor: itemSelected.colorCode,
          promotionPrice: itemSelected.promotionPrice,
          price: itemSelected.price,
          itemStock: itemSelected.stockAvailable,
          cartItemImage: itemSelected.pictures[0],
          promotionCodeDirect: itemSelected.promotionCodeDirect,
          promotionCodeDiscountCode: itemSelected.promotionCodeDiscountCode,
          dimension: itemSelected.dimension || 0,
          vistaCode: itemSelected.vistaCode,
          weight: itemSelected.weight
        };

        if (type !== "voucher") {
          if ((cart || []).length === 0 && !localStorage.getItem("cartGuest")) {
            await CreateCart(model, 'buynow');
          } else {
            await AddOrUpdateProductToCart(model, 'buynow');
          }
          await GetCartData();
        } else {
          AddToBuyNow({ ...model, type: "voucher" }, 'buynow');
        }
        await this.setState({ qty: 1 });
        await history.push(`${basenameURL}/cart`);
      }
    } else {
      OpenDialogLogin();
    }
  };

  handleDialogProductOverStock = () => {
    const { CloseDialogProductOverStock } = this.props;
    setTimeout(() => {
      CloseDialogProductOverStock();
    }, 1500);
  };

  handleZoom = (id, i) => {
    if (this.state.zoom && this.state.zoom['zoom_' + id + '_' + i]) {
      this.setState({ zoom: {} });
    } else {
      this.setState((prevState) => ({
        zoom: {
          ...prevState.zoom,
          ['zoom_' + id]: `${API.REVIEW_IMG_URL}/${id}/${i}.jpg`
        }
      }));
      this.setState((prevState) => ({
        zoom: { ...prevState.zoom, ['zoom_' + id + '_' + i]: true }
      }));
    }
  };

  render() {
    const {
      lightboxOpen,
      lightboxSource,
      lightboxSlide,
      galleryResource,
      thumbSelected,
      itemSelected,
      qty,
      btnAddItemToCartAndBuyNow,
      colors,
      sizes,
      sizeSelected
    } = this.state;

    const {
      product,
      itemName,
      dialogStock,
      dialogAddProductToCart,
      AutoCloseDialogAddProductToCart,
      CloseDialogProductOverStock,
      wording,
      currentLanguage,
      navbarCategory,
      type,
      basenameURL
    } = this.props;

    if (product && type === 'product' && product.items.length === 0) {
      return <Page404 />;
    }

    const outOfStock = itemSelected 
      ? itemSelected.stockAvailable === 0 || (this.findAmountInCart() + 1) > itemSelected.stockAvailable
      : false;

    return (
      <>
        {itemSelected ? (
          <>
            <DialogAddProductToCart
              open={dialogAddProductToCart}
              closeDialog={AutoCloseDialogAddProductToCart}
            />
            <DialogProductOverStock
              open={dialogStock}
              closeDialog={CloseDialogProductOverStock}
            />
            <ProductTitle itemName={itemName} />
            <section className="section-wrap-small single-product">
              <FsLightbox
                toggler={lightboxOpen}
                sources={lightboxSource}
                type="image"
                slide={lightboxSlide}
              />
              <div className="container relative">
                <div className="row">
                  <div className="col-sm-6 col-xs-12 mb-60">
                    <ProductGalleryMain
                      galleryResource={galleryResource}
                      handleOpenLightbox={this.handleOpenLightbox}
                    />
                    <div className="gallery-thumbs">
                      {itemSelected.pictures.map((img, index) => {
                        return (
                          <div
                            key={`gallery-cell-${index}`}
                            className={classNames('gallery-cell', {
                              'is-selected is-nav-selected':
                                index === thumbSelected
                            })}
                            onClick={() =>
                              this.handleThumbSelected(index, img)
                            }>
                            <img
                              src={`${API.PRODUCT_IMG_URL}${img}`}
                              alt={img}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="col-sm-6 col-xs-12 product-description-wrap">
                    <ProductName name={product.name} rating={product.rating} />

                    <ProductPrice
                      promotionPrice={itemSelected.promotionPrice || 0}
                      price={itemSelected.price}
                      promotionName={itemSelected.promotionName}
                    />
                    <ProductDescription description={product.desc} />
                    {colors.length !== 0 &&
                      colors.every(
                        (color) => !['null', 'undefined'].includes(color.name)
                      ) && (
                        <div className="color-select clearfix mb-30">
                          <h5>{`${wording.productPage.product.color}:`}</h5>
                          <ul className="color-swatches clearfix">
                            {colors.map(({ name }) => {
                              return (
                                <li key={`btn-color-${name}`}>
                                  <a
                                    className={classNames('pointer', {
                                      selected: name === itemSelected.colorCode
                                    })}
                                    style={{
                                      backgroundColor: name
                                    }}
                                    onClick={() => this.handleColorChange(name)}
                                  />
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      )}
                    {sizes.length > 0 &&
                      sizes.every(
                        (size) => !['null', 'undefined'].includes(size)
                      ) && (
                        <div className="size-options clearfix mb-30">
                          <h5>{`${wording.productPage.product.size}:`}</h5>
                          {sizes.map((size) => {
                            return (
                              <a
                                key={`size-${size}`}
                                className={classNames('pointer', {
                                  selected:
                                    size === itemSelected.sizeName &&
                                    sizeSelected
                                })}
                                onClick={() => this.handleSizeChange(size)}>
                                {size}
                              </a>
                            );
                          })}
                        </div>
                      )}
                    {product.material && (
                      <div className="size-options clearfix mb-30">
                        <h5>{`${wording.productPage.product.material}:`}</h5>
                        <p className="white" style={{ fontSize: '16px' }}>
                          {product.material}
                        </p>
                      </div>
                    )}
                    {product.expireDate && (
                      <div className="size-options clearfix mb-30">
                        <p className="white">
                          {`${wording.productPage.product.expireDate} `}
                          {formatDate(product.expireDate)[currentLanguage]}
                        </p>
                      </div>
                    )}
                    {
                      itemSelected.promotionCondition && (
                        <div className="size-options clearfix mb-30">
                          <h5>{`${wording.productPage.product.promotionCondition}:`}</h5>
                            <ProductDescription description={itemSelected.promotionCondition} className="mt-0" />
                        </div>
                      )
                    }
                    <ul className="react-product-actions clearfix">
                      <li>
                        <div className="quantity buttons_added">
                          <input
                            disabled={!sizeSelected}
                            type="button"
                            defaultValue="-"
                            className="react_minus"
                            onClick={this.handleDecreaseQty}
                          />

                          <input
                            type="number"
                            title="Qty"
                            className="input-text qty text"
                            value={sizeSelected ? qty : 0}
                            onChange={(e) => this.handleQtyChange(e)}
                            onBlur={() => this.handleQtyBlur()}
                          />

                          <input
                            disabled={!sizeSelected}
                            type="button"
                            defaultValue="+"
                            className="react_plus"
                            onClick={this.handleIncreaseQty}
                          />
                        </div>
                      </li>
                      <li>
                        <p
                          style={{
                            position: 'absolute',
                            marginTop: -32,
                            color:
                              outOfStock
                                ? 'red'
                                : 'white'
                          }}>
                          {sizeSelected &&
                            (itemSelected.stockAvailable === 0
                              ? `${wording.homePage.newArrivals.outOfStock}`
                              : this.findAmountInCart() > 10 && type == "voucher"
                                  ? `${wording.productPage.product.limit.before} 10 ${wording.productPage.product.limit.after}`
                                  : itemSelected.stockAvailable <= 5
                                    ? `${wording.productPage.product.only} ${itemSelected.stockAvailable} ${wording.productPage.product.only2}`
                                    : null
                            )}
                        </p>
                      </li>
                    </ul>
                    <ul className="product-actions clearfix mt-20 mb-20">
                      <li>
                        <a
                          className="btn btn-light btn-md add-to-cart left pointer mt-0 mb-0"
                          disabled={btnAddItemToCartAndBuyNow}
                          onClick={this.handleAddToCart}>
                          {wording.productPage.product.addToCart}
                        </a>
                      </li>
                      <li>
                        <a
                          className="btn btn-dark btn-md add-to-cart left pointer mt-0 mb-0"
                          disabled={btnAddItemToCartAndBuyNow}
                          onClick={this.handleBuyNow}>
                          {wording.productPage.product.buyNow}
                        </a>
                      </li>
                    </ul>
                    <ProductShare />
                  </div>
                </div>

                {type != "voucher" &&
                  product.items[0].review &&
                  product.items[0].review.length > 0 && (
                    <div>
                      {product.items[0].review.map((item, i) => {
                        let img = [];
                        for (let i = 1; i <= Number(item.imageAmount); i++) {
                          img.push(
                            <div
                              key={'img_' + item.id + '_' + i}
                              style={{
                                width: 120,
                                height: 120,
                                marginRight: 20,
                                cursor:
                                  this.state.zoom &&
                                    this.state.zoom['zoom_' + item.id + '_' + i]
                                    ? 'zoom-out'
                                    : 'zoom-in',
                                backgroundImage: `url(${API.REVIEW_IMG_URL}/${item.id}/${i}.jpg)`,
                                backgroundSize: 500,
                                backgroundRepeat: 'no-repeat',
                                backgroundPositionX: '50%',
                                backgroundPositionY: '50%'
                              }}
                              onClick={() => this.handleZoom(item.id, i)}
                            />

                            // <img
                            //   src={`${API.REVIEW_IMG_URL}/${item.id}/${i}.jpg`}
                            //   style={{
                            //     marginRight: 20,
                            //     width: 80,
                            //     height: 80,
                            //     cursor:
                            //       this.state.zoom &&
                            //       this.state.zoom['zoom_' + item.id + '_' + i]
                            //         ? 'zoom-out'
                            //         : 'zoom-in'
                            //   }}
                            //   onClick={() => this.handleZoom(item.id, i)}
                            // />
                          );
                        }

                        return (
                          <div
                            key={'review_' + i}
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              marginBottom: 10
                            }}>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row'
                              }}>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  marginBottom: 20
                                }}>
                                <div style={{ marginBottom: 10 }}>
                                  {item.reviewer}
                                </div>
                                <div>
                                  <StarRatings
                                    name="rating"
                                    rating={Number(item.point)}
                                    starDimension={'20'}
                                    numberOfStars={STAR.NUMBER_OF_STAR}
                                    starRatedColor={STAR.RATED_COLOR}
                                    starEmptyColor={STAR.EMPTY_COLOR}
                                    starSpacing={STAR.SPACING}
                                    svgIconPath={STAR.svgIconPath}
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>

                            {item.comment && (
                              <div style={{ marginBottom: 20 }}>
                                {item.comment}
                              </div>
                            )}

                            {img.length > 0 && (
                              <div
                                style={{
                                  marginBottom: 20,
                                  display: 'flex',
                                  flexDirection: 'row'
                                }}>
                                {img}
                              </div>
                            )}

                            {this.state.zoom &&
                              this.state.zoom['zoom_' + item.id] && (
                                <div style={{ marginBottom: 20 }}>
                                  <img
                                    src={
                                      this.state.zoom &&
                                      this.state.zoom['zoom_' + item.id]
                                    }
                                    style={{ width: 320 }}
                                  />
                                </div>
                              )}

                            <div>
                              {moment(item.created).format(
                                'YYYY-MM-DD HH:mm:ss'
                              )}
                            </div>

                            <hr
                              style={{ borderColor: '#fff', width: '100%' }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  )}
              </div>
            </section>
          </>
        ) : (
            <>
              <section className="section-wrap pt-70 pb-40 catalogue">
                <div className="container relative">
                  <div className="row">
                    <div className="col-md-12 mb-50">
                      <div className="shop-catalogue grid-view">
                        <div className="row text-center">
                          <div className="col-md-10 col-md-offset-1">
                            <div className="icon-warpper">
                              <img
                                src="/assets/img/sf/not-found.png"
                                alt="not-found.png"
                              />
                            </div>
                            <h1 className="uppercase">
                              {wording.unableItem.bodyMessage}
                            </h1>
                            <p className="white">
                              {wording.unableItem.urlMessage1}{' '}
                              <Link to={`${basenameURL}`}>
                                {currentLanguage === 'TH'
                                  ? navbarCategory[0].categoryNameTh
                                  : navbarCategory[0].categoryNameEn}
                              </Link>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </>
          )}
      </>
    );
  }
}

const mapStateToProps = ({ login, product, cart, language, navigation }) => ({
  firebaseAuth: login.firebaseAuth,
  product: product.data,
  dialogStock: product.dialogStock,
  dialogAddProductToCart: cart.dialogAddProductToCart,
  cart: cart.data,
  buyNow: cart.buyNow.item,
  wording: language.wording,
  currentLanguage: language.currentLanguage,
  navbarCategory: navigation.navbarCategory,
  basenameURL: language.basenameURL
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      OpenDialogLogin: Actions.OpenDialogLogin,
      CreateCart: Actions.CreateCart,
      AddOrUpdateProductToCart: Actions.AddOrUpdateProductToCart,
      GetCartData: Actions.GetCartData,
      AutoCloseDialogAddProductToCart: Actions.AutoCloseDialogAddProductToCart,
      OpenDialogProductOverStock: Actions.OpenDialogProductOverStock,
      CloseDialogProductOverStock: Actions.CloseDialogProductOverStock,
      AddToBuyNow: Actions.AddToBuyNow
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductMain)
);
